/**
 * Resubmit comment modal — "再提出を依頼しますか?" dialog.
 * Opens when admin clicks 再提出を依頼する; admin enters reason for resubmission.
 */
import React from 'react';
import cautionIcon from '../../../../assests/icons/caution.png';
import './ResubmitCommentModal.css';

export interface ResubmitCommentModalProps {
  /** When true, the modal is visible */
  open: boolean;
  /** Current value of the reason textarea */
  reason: string;
  /** Called when the user types in the textarea */
  onReasonChange: (value: string) => void;
  /** Called when user clicks キャンセル or the close (×) button */
  onClose: () => void;
  /** Called when user clicks 保存 */
  onSave: () => void;
}

const ResubmitCommentModal: React.FC<ResubmitCommentModalProps> = ({
  open,
  reason,
  onReasonChange,
  onClose,
  onSave,
}) => {
  if (!open) return null;

  return (
    <div
      className="resubmit-comment-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="resubmit-comment-modal-title"
    >
      <div className="resubmit-comment-modal__backdrop" />
      <div className="resubmit-comment-modal__box">
        <div className="resubmit-comment-modal__header">
          <img src={cautionIcon} alt="" className="resubmit-comment-modal__icon" aria-hidden />
          <h3 id="resubmit-comment-modal-title" className="resubmit-comment-modal__title">
            再提出を依頼しますか?
          </h3>
          <button
            type="button"
            className="resubmit-comment-modal__close"
            aria-label="閉じる"
            onClick={onClose}
          >
            ×
          </button>
        </div>
        <p className="resubmit-comment-modal__instruction">
          従業員へ再提出を依頼する理由を入力してください。
        </p>
        <textarea
          className="resubmit-comment-modal__textarea"
          value={reason}
          onChange={(e) => onReasonChange(e.target.value)}
          placeholder=""
          rows={5}
          aria-label="再提出理由"
        />
        <div className="resubmit-comment-modal__footer">
          <button type="button" className="resubmit-comment-modal__cancel-btn" onClick={onClose}>
            キャンセル
          </button>
          <button type="button" className="resubmit-comment-modal__save-btn" onClick={onSave}>
            保存
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResubmitCommentModal;
